'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styles$d = require('./styles-ab89d1c5.js');

var ContactUsBlock = function (_a) {
    var buttonTitle = _a.buttonTitle, buttonText = _a.buttonText, supportEmail = _a.supportEmail, emailSubject = _a.emailSubject;
    return (React__default.createElement(styles$d.Container, { "data-testid": "contact-us-block" },
        React__default.createElement(styles$d.Title, null, buttonTitle),
        React__default.createElement(styles$d.MailTo, { href: "mailto:" + supportEmail + "?subject=" + (emailSubject || buttonText) },
            React__default.createElement(styles$d.StyledButton, { size: "sm", text: buttonText, variant: constants.BUTTON_VARIANT.CLOSE_BUTTON }))));
};

exports.ContactUsBlock = ContactUsBlock;
